// 用户自定义语言资源 中文
function getLocaleResource(){
    const data:any = {};
    return data;
}
export default getLocaleResource;